export { DMS_MODULE } from '@/modules/ciselnik/constants';
// TODO: upravit CRUMB_LABEL_KEY
export const CRUMB_LABEL_KEY = 'edtPujcovna';
export const NAME = <const>'NahradniSazbaPujcovna';
